import { ComponentType } from 'react';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import CategoryIcon from '@material-ui/icons/Category';
import ExtensionIcon from '@material-ui/icons/Extension';
import LibraryBooks from '@material-ui/icons/LibraryBooks';
import MapIcon from '@material-ui/icons/MyLocation';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import AssessmentIcon from '@material-ui/icons/Assessment';
import StorefrontIcon from '@material-ui/icons/Storefront';
import CloudOffIcon from '@material-ui/icons/CloudOff';

export interface SystemTile {
  id: string;
  title: string;
  description: string;
  icon: ComponentType<SvgIconProps>;
  url: string;
}

export interface UserTilePreferences {
  visibleTileIds: string[];
  dismissedNewTileIds: string[];
  version: number;
}

export const STORAGE_BUCKET = 'homepage-tiles';
export const PREFERENCES_KEY = 'preferences';
export const PREFERENCES_VERSION = 1;

export const DEFAULT_TILES: SystemTile[] = [
  {
    id: 'catalog',
    title: 'Catalog',
    description:
      'Browse and manage your software components, services, and resources',
    icon: CategoryIcon,
    url: '/catalog',
  },
  {
    id: 'apis',
    title: 'APIs',
    description: 'Explore and discover APIs across your organization',
    icon: ExtensionIcon,
    url: '/api-docs',
  },
  {
    id: 'docs',
    title: 'Documentation',
    description: 'Access technical documentation and guides',
    icon: LibraryBooks,
    url: '/docs',
  },
  {
    id: 'tech-radar',
    title: 'Tech Radar',
    description: 'View technology adoption and recommendations',
    icon: MapIcon,
    url: '/aoe-radar',
  },
  {
    id: 'teams',
    title: 'Teams',
    description: 'View teams and organizational structure',
    icon: AccountTreeIcon,
    url: '/teams',
  },
  {
    id: 'analytics',
    title: 'Analytics',
    description:
      'Track adoption metrics and best practices across your organization',
    icon: AssessmentIcon,
    url: '/analytics',
  },
  {
    id: 'ai-marketplace',
    title: 'AI Marketplace',
    description: 'Browse and discover Claude plugins for your workflows',
    icon: StorefrontIcon,
    url: '/ai-marketplace',
  },
  {
    id: 'external-down-detector',
    title: 'External Down Detector',
    description:
      'Live status of third-party vendors we depend on (GitHub, Anthropic, AWS, Slack…).',
    icon: CloudOffIcon,
    url: '/external-down-detector',
  },
];

export const DEFAULT_TILE_IDS: string[] = DEFAULT_TILES.map(t => t.id);
